<site-header></site-header>
<ion-content>
  <ion-row class="ion-align-items-center ion-justify-content-center">
    <ion-col sizeLg="8" class="inside-col">
      <div class="holder">
        <div class="the-list">
          <div class="the-card">
            <ion-item detail lines="none">
              <ion-label>Service 1</ion-label>
            </ion-item>
          </div>

          <div class="the-card">
            <ion-item detail lines="none">
              <ion-label>Service 1</ion-label>
            </ion-item>
          </div>

          <div class="the-card">
            <ion-item detail lines="none">
              <ion-label>Service 1</ion-label>
            </ion-item>
          </div>

          <div class="the-card">
            <ion-item detail lines="none">
              <ion-label>Service 1</ion-label>
            </ion-item>
          </div>
        </div>
      </div>
    </ion-col>
  </ion-row>
</ion-content>
